<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="work-flow-pla-title" :field="fields?.title" tag="h2" />
      <div class="work-flow-pla-content">
        <AdaptiveImage
          class="work-flow-pla-content-stepimage"
          :field="fields?.stepImage"
          :isBackground="false"
          :lazy-load="false"
          :enableScrollDetection="false"
          :show="true"
        />
      </div>
      <JssRichText class="work-flow-pla-subtitle" :field="fields?.subtitle" />
      <div class="work-flow-pla-list" v-if="fields?.cardList?.length > 0">
        <div class="work-flow-pla-list-item" v-for="item in fields?.cardList" :key="item?.id">
          <div class="work-flow-pla-list-item-content">
            <JssRichText
              class="work-flow-pla-list-item-title"
              :field="item?.fields?.title"
              tag="h3"
            />
            <JssRichText class="work-flow-pla-list-item-subtitle" :field="item?.fields?.subtitle" />
          </div>
          <JssRichText class="work-flow-pla-list-item-desc" :field="item?.fields?.desc" />
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'WorkFlowPla',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'work-flow-pla'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.work-flow-pla {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-subtitle {
    background: #f6faf9;
    line-height: 1.2;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    margin-top: 24px;
    padding: 16px 20px;
    color: $grey-black;
  }

  &-content {
    width: 100%;
    overflow: auto;
    margin-top: 16px;

    &::-webkit-scrollbar {
      display: none;
    }

    &-stepimage {
      width: 1135px;
      height: auto;
    }
  }

  &-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;

    &-item {
      flex: 1;
      padding: 20px;
      border: 1px solid #ececec;
      border-radius: 16px;

      &-content {
        padding: 16px;
        background: rgba($blue-night, 0.1);
        border-radius: 12px;
      }

      &-title {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
        color: $grey-black;
      }

      &-subtitle {
        font-size: 14px;
        font-weight: 400;
        line-height: 1.2;
        color: $grey-black;
        margin-top: 8px;
      }

      &-desc {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
        color: $grey-black;
        margin-top: 12px;

        li + li {
          margin-top: 6px;
        }
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-content {
      &-stepimage {
        width: 100%;
      }
    }

    &-list {
      flex-direction: row;
    }
  }
}
</style>
